import React from "react";
import "../styles/App.css";
import MapForm from "./MapForm";

export default class Map extends React.Component{
    render() {
        return (
            <div className="map-container normal-margin">
                <div className="form">
                    <MapForm/>
                </div>
                <div className="map-content">
                    <div className="pantalla">
                        Estrado/Pantalla
                    </div>
                    <div className="map"></div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Map.js